import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider, setupAutoUpdate } from '@mobi/web';
import '@mobi/web/styles.css';
import { App } from './App.js';

setupAutoUpdate();

const root = document.getElementById('root');
if (!root) throw new Error('elemento #root não encontrado');

createRoot(root).render(
  <StrictMode>
    <BrowserRouter>
      <AuthProvider expectedRole="admin">
        <App />
      </AuthProvider>
    </BrowserRouter>
  </StrictMode>,
);
